export const SET_IS_START_SERVICE_LEVEL = "SET_IS_START_SERVICE_LEVEL";
export const SET_IS_FAILED_SERVICE_LEVEL = "SET_IS_FAILED_SERVICE_LEVEL";
export const SET_IS_SUCCESS_SERVICE_LEVEL = "SET_IS_SUCCESS_SERVICE_LEVEL";
export const SET_IS_NEED_TO_RELOAD_SERVICE_LEVEL =
  "SET_IS_NEED_TO_RELOAD_SERVICE_LEVEL";
export const SET_PAGINATION_DATA_SERVICE_LEVEL =
  "SET_PAGINATION_DATA_SERVICE_LEVEL";
